import React, { useEffect, useState, useImperativeHandle } from 'react'
import DataSheet from './dataSheet'
import { handleSave } from './handleSave'
import VendorAdvancesServices from 'Services/Api/MasterData/vendorAdvances'

const fields = [
  'bpCode',
  'bpName'
]
const params = {
  order: true,
  orderBy: '_id',
  sort: 1,
  search: toString()
}
export default function Spreadsheet () {
  const [data, setData] = useState([])
  const [refresh, setRefresh] = useState(false)
  useEffect(() => {
    VendorAdvancesServices.getMany(params).then(async response => {
        const data = response.data.data
        const newData = []
        for (const i of data) {
          newData.push({
            bpCode: i.bpCode,
            bpName: i.bpName
          })
        }
        const headers = [{ value: '', readOnly: true }]
        for (const field of fields) {
          headers.push({ value: field, readOnly: true })
        }
        const grid = [[...headers]]
        // const { data } = await response.json()
        let index = 0
        for (const obj of newData) {
          index = index + 1
          const data = [{ value: index, readOnly: true }]
          for (const field of fields) {
            data.push({ value: obj[field] })
          }
          grid.push([...data])
        }
        setData(grid)
        setRefresh(false)
      })
      .catch(err => {
          
        setRefresh(false)
      })
  }, [refresh])

  return (
    <div>
      <DataSheet
        data={data}
        refresh={() => setRefresh(true)}
        save={data => handleSave(data, fields, 'vendor-advances')}
      />
    </div>
  )
}
